var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextField, Typography } from '@mui/material';
export var TextInputComponent = function (_a) {
    var _b, _c, _d, _e;
    var input = _a.input, config = _a.config, theme = _a.theme, onChange = _a.onChange, readonly = _a.readonly;
    var userConfigValue = (_b = config === null || config === void 0 ? void 0 : config.inputConfigs) === null || _b === void 0 ? void 0 : _b[input.macroName];
    var currentSetting = (_e = userConfigValue !== null && userConfigValue !== void 0 ? userConfigValue : (_d = (_c = theme === null || theme === void 0 ? void 0 : theme.config) === null || _c === void 0 ? void 0 : _c.inputConfigs) === null || _d === void 0 ? void 0 : _d[input.macroName]) !== null && _e !== void 0 ? _e : input === null || input === void 0 ? void 0 : input.default;
    return (_jsxs("div", { children: [_jsx(Typography, __assign({ variant: "h6", color: "primary" }, { children: input.label })), _jsx(TextField, { disabled: readonly, value: currentSetting, onChange: function (event) {
                    var value = event.target.value;
                    onChange(value);
                }, fullWidth: true })] }));
};
